<template>
  <div class="profile old-globals">
    <profile-form />
  </div>
</template>

<script>
import ProfileForm from '../../components/account/ProfileForm';

export default {
  name: 'profile',
  components: {
    ProfileForm,
  },
  data: () => ({
    state: {},
  }),
  methods: {},
};
</script>

<style scoped>
</style>
